import { render } from "./EditHome.vue?vue&type=template&id=0eaf7e33&scoped=true"
import script from "./EditHome.vue?vue&type=script&lang=js"
export * from "./EditHome.vue?vue&type=script&lang=js"

import "./EditHome.vue?vue&type=style&index=0&id=0eaf7e33&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eaf7e33"]])

export default __exports__